module.exports = __webpack_public_path__ + "static/img/shiftHandover.72d5ef57.svg";